export interface SpotlightDirectoriesFilters {
  start_date: string;
  end_date: string;
  corporation_id: number;
  include_time_series?: boolean;
  grouping?: 'monthly' | 'quarterly' | 'yearly';
  page?: number;
  per_page?: number;
  limit?: number;
}
